import React, { useEffect, useState } from 'react';

import {
  BodyTypography,
  Button,
  ButtonIconPositionEnum,
  ButtonVariationsEnum,
  FontSizeEnum,
  FontWeightEnum,
} from '@argenta/react-ui';
import { faAngleDown } from '@fortawesome/pro-light-svg-icons';
import { Trans } from '@lingui/macro';

import { VacancySummary } from '../VacancySummary';

import { VacanciesOverviewProps } from './VacanciesOverview.types';

import './VacanciesOverview.styles.scss';

const countPage = 15;

export const VacanciesOverview: React.FunctionComponent<VacanciesOverviewProps> = ({
  vacancies = [],
  enablePager,
  showDescription = true,
}) => {
  const [count, setCount] = useState<number | undefined>(enablePager ? countPage : undefined);
  useEffect(() => setCount(15), [vacancies]);
  return (
    <div className="argnt-vacancies-overview">
      <div className="argnt-vacancies-overview--content">
        {vacancies.length > 0 ? (
          <div className="argnt-vacancies-overview--list">
            {vacancies.slice(0, count).map((vacancy) => {
              const { dateAdded, description, link, location, title, schedule, id } = vacancy;
              return (
                <VacancySummary
                  key={id}
                  id={id}
                  link={link || ''}
                  title={title}
                  description={showDescription ? description : undefined}
                  location={location}
                  dateAdded={dateAdded}
                  schedule={schedule}
                />
              );
            })}
            {/* adding 1 because 0 based */}
            {enablePager && count && count <= vacancies.length - 1 && (
              <div className="argnt-vacancies-overview--pager">
                <Button
                  variation={ButtonVariationsEnum.LINK}
                  onClick={() => setCount(count + countPage)}
                  icon={faAngleDown}
                  iconPosition={ButtonIconPositionEnum.RIGHT}
                >
                  <Trans id="vacancies.overview.loadMore" />
                </Button>
              </div>
            )}
          </div>
        ) : (
          <div className="argnt-vacancies-overview--empty--list">
            <BodyTypography fontSize={FontSizeEnum.MEDIUM} fontWeight={FontWeightEnum.REGULAR}>
              <Trans id="vacancies.overview.emptyList" />
            </BodyTypography>
          </div>
        )}
      </div>
    </div>
  );
};
